import { PersonOption } from '@/shared/ui/PersonOption/PersonOption';
import type { ExecutorResponse } from '@/core/generated/api';
import classes from './AssignExecutorModal.module.scss';

// Поле уже есть в backend-контракте и будет включено после регенерации API-клиента.
type ExecutorWithReviewCount = ExecutorResponse & { reviewCount?: number };

/** Показывает исполнителя с рейтингом и количеством отзывов. */
export const ExecutorOptionRow = (
    {
        executor,
        selected = false,
    }: { executor: ExecutorWithReviewCount; selected?: boolean }
) => {
    const name = [executor.name?.trim(), executor.lastName?.trim()].filter(Boolean).join(' ')
        || 'Исполнитель без имени';

    const rating = executor.rating == null
        ? 'Нет оценки'
        : executor.rating.toFixed(2);

    return <PersonOption
        name={name}
        phone={executor.phone}
        photoUrl={executor.photoUrl}
        details={executor.cityName ?? undefined}
        blocked={executor.isBlocked}
        selected={selected}
    >
        <span className={classes.executorStats}>
            <span
                className={classes.rating}
                aria-label={`Рейтинг: ${rating}`}
            >
                <i
                    className="pi pi-star-fill"
                    aria-hidden="true"
                /> {rating}
            </span>
            <span className={classes.reviewCount}>Отзывы: {executor.reviewCount ?? '—'}</span>
        </span>
    </PersonOption>;
};
